import {
  LIST_CONFIGURATION_REQUEST,
  LIST_CONFIGURATION_SUCCESS,
  LIST_CONFIGURATION_FAIL,
  LIST_CONFIGURATION_SUMMARY_REQUEST,
  LIST_CONFIGURATION_SUMMARY_SUCCESS,
  LIST_CONFIGURATION_SUMMARY_FAIL
} from '../../constants/configuration'

const initialState = {
  loadingConfigurationSummary: false,
  loadingConfiguration: false,
  configuration: [],
  configurationSummary: [],
  dynamicFormSummaries: [],
  clientsProjectsSummary: [],
  loadingDynamicFormSum: false,
  loadingDetail: false,
  loadingUpdate: false,
  client: {},
  error: null,
  pageable: {}
}

const configurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_CONFIGURATION_REQUEST:
      return { ...state, loadingConfiguration: true }
    case LIST_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingConfiguration: false,
        configuration: action.payload,
        pageable: action.pageable
      }
    case LIST_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingConfiguration: false,
        error: action.payload,
        configuration: []
      }
    case LIST_CONFIGURATION_SUMMARY_REQUEST:
      return { ...state, loadingConfigurationSummary: true }
    case LIST_CONFIGURATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingConfigurationSummary: false,
        configurationSummary: action.payload
      }
    case LIST_CONFIGURATION_SUMMARY_FAIL:
      return {
        ...state,
        loadingConfigurationSummary: false,
        error: action.payload
      }
    case 'DYNAMIC_FORM_SUMMARY_REQUEST':
      return { ...state, loadingDynamicFormSum: true }
    case 'DYNAMIC_FORM_SUMMARY_SUCCESS':
      return {
        ...state,
        loadingDynamicFormSum: false,
        dynamicFormSummaries: action.payload
      }
    case 'DYNAMIC_FORM_SUMMARY_FAIL':
      return {
        ...state,
        loadingDynamicFormSum: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default configurationReducer
